export default "__VITE_ASSET__CoezIZaD__"